<div class="container">
  <div class="landing">
    <section class="hero" id="hero">
      <div class="hero__image">
        <img src="../../../../assets/integrations/telegram.svg" alt="Telegram CRM">
      </div>
      <div class="hero__content">
        <h1 class="hero__title">{{ 'telegram_page.hero_title' | translate }}</h1>
        <p class="hero__subtitle">{{ 'telegram_page.hero_subtitle' | translate }}</p>
        <a [href]="environment.login_url">
          <app-button [title]="'telegram_page.hero_button' | translate"></app-button>
        </a>
      </div>
      <div class="hero__scroll" (click)="scrollTo('features')">
        <app-icon>expand_more</app-icon>
      </div>
    </section>

    <section class="section-container" id="features">
      <h2 class="section-title">{{ 'telegram_page.features_title' | translate }}</h2>
      <ul class="features-list">
        <li>{{ 'telegram_page.feature_1' | translate }}</li>
        <li>{{ 'telegram_page.feature_2' | translate }}</li>
        <li>{{ 'telegram_page.feature_3' | translate }}</li>
        <li>{{ 'telegram_page.feature_4' | translate }}</li>
        <li>{{ 'telegram_page.feature_5' | translate }}</li>
        <li>{{ 'telegram_page.feature_6' | translate }}</li>
        <li>{{ 'telegram_page.feature_7' | translate }}</li>
      </ul>
    </section>

    <section class="section-container" id="ai-manager">
      <h2 class="section-title">{{ 'telegram_page.ai_title' | translate }}</h2>
      <ul class="features-list">
        <li>{{ 'telegram_page.ai_feature_1' | translate }}</li>
        <li>{{ 'telegram_page.ai_feature_2' | translate }}</li>
        <li>{{ 'telegram_page.ai_feature_3' | translate }}</li>
      </ul>
    </section>

    <app-interface-for-all></app-interface-for-all>

    <section class="section-container" id="for-whom">
      <h2 class="section-title">{{ 'telegram_page.audience_title' | translate }}</h2>
      <ul class="audience-list">
        <li>{{ 'telegram_page.audience_1' | translate }}</li>
        <li>{{ 'telegram_page.audience_2' | translate }}</li>
        <li>{{ 'telegram_page.audience_3' | translate }}</li>
        <li>{{ 'telegram_page.audience_4' | translate }}</li>
      </ul>
    </section>

    <app-advantages></app-advantages>

    <app-reviews></app-reviews>

    <section class="section-container" id="faq">
      <h2 class="section-title">{{ 'telegram_page.faq_title' | translate }}</h2>
      <div class="faq-list">
        <div class="faq-item">
          <h3 class="faq-question">{{ 'telegram_page.faq_1_question' | translate }}</h3>
          <p class="faq-answer">{{ 'telegram_page.faq_1_answer' | translate }}</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">{{ 'telegram_page.faq_2_question' | translate }}</h3>
          <p class="faq-answer">{{ 'telegram_page.faq_2_answer' | translate }}</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">{{ 'telegram_page.faq_3_question' | translate }}</h3>
          <p class="faq-answer">{{ 'telegram_page.faq_3_answer' | translate }}</p>
        </div>
        <div class="faq-item">
          <h3 class="faq-question">{{ 'telegram_page.faq_4_question' | translate }}</h3>
          <p class="faq-answer">{{ 'telegram_page.faq_4_answer' | translate }}</p>
        </div>
      </div>
    </section>

    <section class="section-container" id="final-cta">
      <h2 class="section-title">{{ 'telegram_page.cta_title' | translate }}</h2>
      <a [href]="environment.login_url">
        <app-button [title]="'telegram_page.cta_button' | translate" [isOutline]="true"></app-button>
      </a>
      <p class="cta-subtext">{{ 'telegram_page.cta_subtext' | translate }}</p>
    </section>

    <app-integration-review
      [youtubeReviewLink]="'https://www.youtube.com/embed/hkLuuMCeKuk'"
      [youtubeReviewTitle]="'telegram.title' | translate"
    ></app-integration-review>
  </div>
</div>
